import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "listPageHeader",
  props: {
    pageHeader: {
      type: String,
      required: true,
    },
    showMenu: {
      type: Boolean,
      required: true,
    },
  },

  setup(_props, _ctx) {
    return {};
  },
});
